import { Names } from '@mode-switch/model';
import { Encoding, MarkType } from '@mode-vegas/vegas';

export enum Shape {
  Combo = 'COMBO',
  Grouped = 'GROUPED',
  Stacked = 'STACKED',
  Radial = 'RADIAL',
  BigValue = 'BIG_VALUE',
}

export function shape(encoding: Encoding): Shape {
  const markType = getMarkType(encoding);
  const namesOnX = hasNamesOnX(encoding);
  const multiSeries = isMultiSeries(encoding);

  if (multiSeries) {
    return Shape.Combo;
  }

  if (namesOnX) {
    return Shape.Grouped;
  }

  switch (markType) {
    case MarkType.Pie:
    case MarkType.Donut:
      return Shape.Radial;
    case MarkType.Text:
      return Shape.BigValue;
    default:
      return Shape.Stacked;
  }
}

export function getMarkType(encoding: Encoding): MarkType | undefined {
  if (encoding.marks.series.length > 0) {
    return encoding.marks.series[0].properties.type.value;
  } else {
    return encoding.marks.properties.type.value;
  }
}

export function isMultiSeries(encoding: Encoding): boolean {
  return encoding.marks.series.length > 1;
}

export function hasNamesOnX(encoding: Encoding): boolean {
  return encoding.x.length > 0 && encoding.x[0].formula === Names.Key;
}

export function hasFieldOnSize(encoding: Encoding): boolean {
  return encoding.marks.series.length > 0 && encoding.marks.series[0].properties.size.values.length > 0;
}
